module.exports = __webpack_public_path__ + "img/new-year_zh.a309c0e3.png";